export default __webpack_public_path__ + "static/media/information--directions--g1.5b231c54.png";